import { h, render } from 'preact';
import { StepCounter } from './stepCounter.component';
import { ViewHeadline } from './viewHeadline.component';
import { FlowButton } from './flowButton.component';
import { ButtonLayout } from '../containers/buttonLayout.container';

export function InjuryType() {
  const pageHeader = {
    headline: 'What type of injuries did you suffer?'
  };

  const headlineChild = (
    <ViewHeadline {...pageHeader} />
  );

  const progressChild = (
    <StepCounter
      currentStep={3}
      totalSteps={8} />
  );

  const modelProp = 'injuryType';
  const nextUrl = 'medical-treatment';

  const btnData = [
    {
      to: nextUrl,
      modelVal: 'Whiplash',
      modelProp,
      buttonText: 'Whiplash',
      component: FlowButton
    },
    {
      to: nextUrl,
      modelVal: 'Broken Bones',
      modelProp,
      buttonText: 'Broken Bones',
      component: FlowButton
    },
    {
      to: nextUrl,
      modelVal: 'Cuts & Bruises',
      modelProp,
      buttonText: 'Cuts & Bruises',
      component: FlowButton
    },
    {
      to: nextUrl,
      modelVal: 'Serious Injury Requiring Medical Attention',
      modelProp,
      buttonText: 'Serious Injury Requiring Medical Attention',
      component: FlowButton
    },
    {
      to: nextUrl,
      modelVal: 'Other Injuries',
      modelProp,
      buttonText: 'Other Injuries',
      component: FlowButton
    },
    {
      to: nextUrl,
      modelVal: 'I was not hurt',
      modelProp,
      buttonText: 'I was not hurt',
      component: FlowButton
    }
  ];

  return (
    <ButtonLayout
      headlineChild={headlineChild}
      progressChild={progressChild}
      btnData={btnData}/>
  );
}
